import Checkbox from "components/common/Fields/Checkbox";
import ReactStrapTable from "components/reactStrapTable";
import SearchButtons from "components/SearchButtons";
import React, { useState } from "react";
import columnSelectorIcon from "../../../../../assets/icon/column-selector.svg";

import {
  Button,
  ButtonGroup,
  Col,
  Dropdown,
  DropdownToggle,
  Row,
} from "reactstrap";

const MedicationEditDetails = () => {
  const [rSelected, setRSelected] = useState("off");
 const [tableData, setTableData] = useState(rowData);
      const [data, setData] = useState([]);
  const columnData = [
    {
      dataField: "all",
      text: (
        <div className="d-flex justify-content-flexstart align-items-center gap-2">
          <Checkbox /> All
        </div>
      ),
      show: true,
    },
    {
      dataField: "orderstatus",
      text: "Order Status",
      show: true,
      sort: true,
    },
    {
      dataField: "prescriptionnumber",
      text: "Prescription Number",
      show: true,
      sort: true,
      width: 140,
    },
    {
      dataField: "prescriptionname",
      text: "Prescription Name",
      show: true,
      sort: true,
      width: 140,
    },
    {
      dataField: "pharmacylocation",
      text: "Pharmary Location",
      show: true,
      sort: true,
      width: 140,
    },
    {
      dataField: "drugname",
      text: "Durg Name",
      show: true,
      sort: true,
    },
  ];

  const rowData = [
    {
      all: <Checkbox />,
      orderstatus: "New",
      prescriptionnumber: 123456789,
      prescriptionname: "Smith",
      pharmacylocation: "Lorume",
      drugname: "Lisinopril 10 MG Tablet",
    },
    {
      all: <Checkbox />,
      orderstatus: "New",
      prescriptionnumber: 123456789,
      prescriptionname: "Smith",
      pharmacylocation: "Lorume",
      drugname: "Lisinopril 10 MG Tablet",
    },
    {
      all: <Checkbox />,
      orderstatus: "New",
      prescriptionnumber: 123456789,
      prescriptionname: "Smith",
      pharmacylocation: "Lorume",
      drugname: "Lisinopril 10 MG Tablet",
    },
    // {
    //   all: <Checkbox />,
    //   orderstatus: "New",
    //   prescriptionnumber: 123456789,
    //   prescriptionname: "Smith",
    //   pharmacylocation: "Lorume",
    //   drugname: "Lisinopril 10 MG Tablet",
    // },
    // {
    //   all: <Checkbox />,
    //   orderstatus: "New",
    //   prescriptionnumber: 123456789,
    //   prescriptionname: "Smith",
    //   pharmacylocation: "Lorume",
    //   drugname: "Lisinopril 10 MG Tablet",
    // },
  ];

  const DispenseColumnData = [
    {
      dataField: "all",
      text: (
        <div className="d-flex justify-content-flexstart align-items-center gap-2">
          <Checkbox />
          All
        </div>
      ),
      show: true,
    },
    {
      dataField: "prescriptionnumber",
      text: "Prescription Number",
      show: true,
      sort: true,
      width: 200,
    },
    {
      dataField: "drugname",
      text: "Drug Name",
      show: true,
      sort: true,
      width: 200,
    },
    {
      dataField: "qtydispensed",
      text: "QTY Dispensed",
      show: true,
      sort: true,
      width: 200,
    },
    {
      dataField: "dataofservice",
      text: "Data of Service",
      sort: true,
      show: true,
      width: 200,
    },
    {
      dataField: "transactiontype",
      text: "Transaction Type",
      sort: true,
      show: true,
      width: 200,
    },
    {
      dataField: "patientpayamount",
      text: "Patient Pay Amount",
      sort: true,
      show: true,
      width: 200,
    },
  ];

  const DispenseRowData = [
    {
      all: <Checkbox />,
      prescriptionnumber: 123456789,
      drugname: "Lisinopril 10 MG Tablet",
      qtydispensed: "10 BTL",
      dataofservice: "12/28/2025",
      transactiontype: "10 BTL",
      patientpayamount: "10 BTL",
    },
    {
      all: <Checkbox />,
      prescriptionnumber: 123456789,
      drugname: "Lisinopril 10 MG Tablet",
      qtydispensed: "10 BTL",
      dataofservice: "12/28/2025",
      transactiontype: "10 BTL",
      patientpayamount: "10 BTL",
    },
    {
      all: <Checkbox />,
      prescriptionnumber: 123456789,
      drugname: "Lisinopril 10 MG Tablet",
      qtydispensed: "10 BTL",
      dataofservice: "12/28/2025",
      transactiontype: "10 BTL",
      patientpayamount: "10 BTL",
    },
  ];

  const toggleFilter = () => {
    setRSelected((prev) => (prev === "off" ? "on" : "off"));
  };

  return (
    <div style={{ width: "82vw" }}>
      <div className="medication-edit-popup">
        <div className="medication-body">
          <div className="heading-text">Active Orders</div>
          <Button color="primary">Transfer</Button>
        </div>
        <div
          className="table-card bg-white"
          style={{ margin: "10px", paddingTop: "0px" }}
        >
          <ReactStrapTable
            data={rowData}
            columns={columnData}
            hasPagination={false}
            redRow={[2]}
          />
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center gap-2 m-3 mb-2">
        <div className="d-flex justify-content-start align-items-center gap-2">
          <div className="heading-text">Dispense History</div>
          <div>
            <SearchButtons
              InSize={200}
              placeHolder={"Search by Product name"}
              data={data}
              setFilterData={setTableData}
            />
          </div>
        </div>
        <div className="d-flex justify-content-start align-items-center gap-2">
          <div>
            <Dropdown isOpen={undefined} toggle={undefined} className="clmn">
              <DropdownToggle>
                <img src={columnSelectorIcon} alt="not available" />
                <span>
                  Columns{" "}
                  {/* {totalCount > 0 && (
                                    <div className="totalcount">{totalCount}</div>
                                  )} */}
                </span>
              </DropdownToggle>
            </Dropdown>
          </div>
          <div className="d-flex justify-content-center align-items-center gap-2">
            <span className="f-16 font-weight-600">Filter</span>
            <ButtonGroup className="filter-btn-group">
              <Button
                color="info"
                outline
                onClick={toggleFilter}
                active={rSelected === "off"}
              >
                OFF
              </Button>
              <Button
                color="info"
                outline
                active={rSelected === "on"}
                onClick={toggleFilter}
              >
                ON
              </Button>
            </ButtonGroup>
          </div>{" "}
        </div>
      </div>
      <div className="table-card scroll-table rounded bg-white medication-inner-table">
        <ReactStrapTable data={DispenseRowData} columns={DispenseColumnData} />
      </div>
    </div>
  );
};

export default MedicationEditDetails;
